import { DataHeader, DataSource, Label, Layout, Panel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCommissionsManagement extends Layout {
    dataheaderCommissionsManagement: DataHeader;
    labelRoleRate: Label;
    panelDates: Panel;
    panelDivider1: Panel;
    panelDivider2: Panel;
    panelEditableFields: Panel;
    panelRoleRate: Panel;
    panelStatuses: Panel;
    sourceCommissionsManagement: DataSource;
    sourceOffPayee: DataSource;
    switchEnableCommissionsPayments: Switch;
    tableRoleRate: Table;
    textboxHireDate: Textbox;
    textboxOffPayeeCommissionDrawAmount: Textbox;
    textboxOffPayeeCommissionStatus: Textbox;
    textboxOffPayeeEarningCode: Textbox;
    textboxOffPayeeUserId: Textbox;
    textboxOffPayeeid: Textbox;
    textboxStatus: Textbox;
    textboxTerminationDate: Textbox;
}
